import { createSlice } from '@reduxjs/toolkit';
// Slice dla aktywnego linku w menu
const menuSlice = createSlice({
  name: 'menu',
  initialState: {
    activeMenuItem: '/', // Zmieniona nazwa z activeLink na activeMenuItem
  },
  reducers: {
    setActiveMenuItem(state, action) {
      state.activeMenuItem = action.payload; // Zmieniona nazwa
    },
  },
});

export const { setActiveMenuItem } = menuSlice.actions;
export default menuSlice.reducer;